module.exports = __webpack_public_path__ + "static/img/中国人民警察大学.a801152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/中国人民警察大学.jpg
// module id = 1Rci
// module chunks = 1